import ApiClient from './ApiClient'

import {BLocatorType, BranchLocatorFilter, BranchLocatorUserdata, RetailAndLogisticsContactModel} from '../types/Entities/BranchLocator'

const getbranchlocatorsiteinfo = async (apiClient: ApiClient, payload: BranchLocatorFilter): Promise<BLocatorType> => {
  const queryParams = new URLSearchParams(payload as any).toString();
  return apiClient
    .get<BLocatorType>(`BranchLocator/getbranchlocatorsiteinfo?${queryParams}`)
    .catch(error => { throw error })
}

const getbranchlocatoruserinfo = async (apiClient: ApiClient): Promise<BLocatorType> => {
  return apiClient
    .get<BLocatorType>(`BranchLocator/getbranchlocatoruserinfo`)
    .catch(error => { throw error })
}

const getStores = async (apiClient: ApiClient, storeID: string): Promise<Response> => {
  return apiClient
    .get<Response>(`/api/BranchLocator/getopenhoursstoredetailsbysiteid?siteId=${storeID}`)
    .catch(error => { throw error})
}

const getAllRegionDetails = async (apiClient: ApiClient):
  Promise<RetailAndLogisticsContactModel[]> => {
  return apiClient
    .get<RetailAndLogisticsContactModel[]>(`SiteCareManager/getallregiondetails`)
    .catch(error => { throw error })
}

const getbranchlocatorapi = { getbranchlocatorsiteinfo, getbranchlocatoruserinfo, getStores, getAllRegionDetails }

export default getbranchlocatorapi